import { render, staticRenderFns } from "./jobDetail.vue?vue&type=template&id=e758ea1c"
import script from "./jobDetail.vue?vue&type=script&lang=js"
export * from "./jobDetail.vue?vue&type=script&lang=js"
import style0 from "./jobDetail.vue?vue&type=style&index=0&id=e758ea1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports